import SkeletonProductImage from '@/components/domains/products/skeleton/SkeletonProduct/SkeletonProductImage'
import SkeletonProductInfo from '@/components/domains/products/skeleton/SkeletonProduct/SkeletonProductInfo'

export { SkeletonProductInfo, SkeletonProductImage }
